module.exports = __webpack_public_path__ + "2871beb71687f6a4921510da55cb28d9.mp4";